























import { Vue, Component, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Components
import BasketsForm from "@/components/app/global/baskets/basket/index.vue";

// Types
import { IBasketRoute } from "@/models/baskets";

@Component({
  components: {
    BasketsForm
  },
  computed: {
    ...mapGetters({
      currentOauthClient: "auth/client/currentOauthClient",
      defaultOauthClient: "auth/client/defaultOauthClient",
      isSupportedOauthClient: "auth/client/isSupportedOauthClient",
      defaultOauthClientRedirect: "auth/client/defaultOauthClientRedirect",
      isClientAuthenticated: "auth/client/isAuthenticated",
      isGuestAuthenticated: "auth/guest/isAuthenticated"
    })
  }
})
export default class OrderForm extends Vue {
  public isLoading = true;
  public isClientAuthenticated!: boolean;
  public isGuestAuthenticated!: boolean;
  public isSupportedOauthClient!: boolean;
  public currentOauthClient!: string;
  public defaultOauthClientRedirect!: string;

  // Props
  @Prop({ required: true })
  public basketRoutes!: IBasketRoute[];

  public async created() {
    if (this.isSupportedOauthClient) {
      if (this.isClientAuthenticated || this.isGuestAuthenticated) {
        this.isLoading = false;
        return;
      }
      await this.$store.dispatch("auth/guest/createToken");
      this.isLoading = false;
    }
  }
}
